/**
 * iter-170e — Reusable pill-button range selector used by every
 * dashboard chart (CashForecast, NetWorth, future charts). Extracted
 * from CashForecastChart/NetWorthChart where the markup was
 * duplicated verbatim, just with different "ranges" arrays.
 *
 * Props:
 *   ranges   — [{ value, label }] (label can be a string OR a fn(lang))
 *   value    — currently selected range.value
 *   onChange — (next) → void
 *   testid   — root data-testid for the container, e.g. "forecast-range"
 *   itemTestidPrefix — testid prefix for each button (default: ${testid}-)
 */
export function RangeSelector({ ranges, value, onChange, testid, itemTestidPrefix }) {
  const prefix = itemTestidPrefix || (testid ? `${testid}-` : "range-");
  return (
    <div className="flex gap-1 bg-slate-100 rounded-full p-1" data-testid={testid}>
      {ranges.map((r) => {
        const isActive = value === r.value;
        return (
          <button /* design-system: ALLOW legacy-todo */
            key={r.value}
            type="button"
            data-testid={`${prefix}${r.value}`}
            onClick={() => onChange(r.value)}
            className={`px-3 py-1 text-xs font-bold rounded-full transition-colors ${
              isActive ? "bg-white text-slate-900 shadow-sm" : "text-slate-500"
            }`}
          >
            {r.label}
          </button>
        );
      })}
    </div>
  );
}
